import React from "react";

import { ReactComponent as WarningIcon } from "static/images/warning-alert.svg";
import styles from "./banner.module.scss";

const MfaBanner = () => {
	return (
		<div className={`${styles.bannerContent} ${styles.bannerBackground}`}>
			<section className={styles.mfaBanner}>
				<div className={styles.bannerWarningIcon}>
					<WarningIcon width="25" height="25" />
				</div>
				<p>
					Aurora is introducing Multi-factor Authentication (MFA) to
					the RISE login experience.
				</p>
				<p>Details will be sent to your email.</p>
			</section>
		</div>
	);
};

export default MfaBanner;
